import { saveQuickAddress } from '../../../services';
import { MutationConfig, mutationOptions } from '../../../utils/react-query';

export const saveAddressBookAddress = (config?: MutationConfig<typeof saveQuickAddress>) =>
  mutationOptions({
    mutationFn: saveQuickAddress,
    config,
  });
